

<div class="row">


  <div class="col-md-12 padding-left-0px margin-top-10">
    <div class="card">
      <div class="card-header wh-header border-bottom1px-solidgray border-left15px-solidgray font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px">
        <div class="row">
          <div class="col-md-4">
            <label class="margin-bottom-0px color-backarrow font-weight-bold font-size-25px">Documents</label>            
          </div>

          <div class="col-md-8 ">
            <button (click)="RefreshAll()" class="btn btn-link float-right  padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px margin-left-10px margin-top-5px" type="button" title="Refresh">
              <i class="fas fa-redo color-cycle-icon"></i>
            </button>
            <button type="button" (click)="AddNew()" class="btn btn-primary btn-sm float-right"> Add</button>
          </div>
        </div>

      </div>
      <div class="card-body padding-top-0px">
        <div class="row">
          <!--<div class="col-md-10 padding-right-0px">
            <div class="table-component">
              <div class="table-responsive overflow-x">


                <table class="table table-striped margin-left-zero"
                       cols="auto,2*,*,*,*,*,*,*">

                  <thead class="">
                    <tr>
                      <th class="width-50"></th>


                      <th>Date</th>

                      <th>
                        Title
                      </th>

                      <th></th>



                    </tr>
                  </thead>

                  <tbody class="table-body">
                    <tr *ngFor="let l of CurrentActorDocController">

                      <td class="td-padding">

                        <img [src]='l.DocFriendlyName' class="img-circle object-fit-cover" height="30px" width="30px" />

                      </td>
                      <td>{{l.DocCaptureDate | date:'dd-MMM-yyyy'}}</td>

                      <td>{{l.DocTitle}}</td>

                      <td>
                        <div class="row">
                          <button type="button" (click)="opendocuments(l)"
                                  class="btn  actions-btn-prime2 benfits-button font-size min-width-42px">
                            <i class="fas fa-list"></i>
                          </button>
                          <a (click)="edit_()" class="nav-link-hand education-navlink">
                            <span class="badge"><i class="fas fa-pencil-alt font-size-15px"></i></span>
                          </a>
                          <a (click)="del_()" class="nav-link-hand education-navlink">
                            <span class="badge">
                              <i class="far fa-trash-alt font-size-15px"></i>
                            </span>
                          </a>

                        </div>
                      </td>
                    </tr>

                  </tbody>

                </table>
              </div>
            </div>
          </div>-->
          <div class=" card col-md-3 height-col-md-3 margin-16px border-light-color" *ngFor="let l of CurrentActorDocController">
            <div class="card-body border-3px-solidgray padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px margin-left-0px">
              <img [src]='l.DocFriendlyName' class="image-border-radius nav-link-hand" height="200px" width="100%" (click)="opendocuments(l)" />
              <div class="row-light-background">
                <div class="row">
                  <div class="col-md-12">
                    <label class="margin-bottom-0px color-datacolor font-size-14 margin-left-3px">{{l.DocTitle}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-9">
                    <label class="margin-bottom-0px color-datacolor font-size-14 margin-left-3px">{{l.DocCaptureDate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                  <div class="col-md-3">
                    <a (click)="del_(l.ActorDocPageCode)" class="nav-link-hand education-navlink float-right">
                      <span class="badge">
                        <i class="far fa-trash-alt font-size-15px"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>

</div>

<div *ngIf='isNew'>
  <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

    <div class="comon-box profile-box p-0 comon-box-width">
      <div class="row">
        <div class="col-md-4">
          <h4 class="heading-pinkbg mt-0 margin-bottom-0px">Add Document</h4>
        </div>
        <div class="col-md-8 margin-top-10">

          <button type="submit" class="btn actions-btn-prime nav-link-hand float-right margin-right-10px">Save</button>
          <button type="button"
                  (click)="CancelNewOperation()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
            Cancel
          </button>
        </div>
      </div>


      <div class="row pl-3 pr-3 margin-left-zero">
        <div class="form-group col-md-6 col-xs-12">
          <label for="eventInput4">Document date</label>

          <div class="date-form">
            <input class="form-control" placeholder="Document datez" [minDate]="minDate" [maxDate]="maxDate"
                   name="dp" [(ngModel)]="ValidFrom" ngbDatepicker #d="ngbDatepicker">

            <a (click)="d.toggle()" class="nav-link-hand">
              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

            </a>

          </div>
        </div>
        <div class="form-group col-md-6 col-xs-12">
          <label for="eventInput2">Category</label>
          <input type="text" class="form-control" placeholder="Type" />
          <!--id="CurrentActorEducationInfoRequest.InstituteName"
                 [(ngModel)]="CurrentActorEducationInfoRequest.InstituteName" name="CurrentActorEducationInfoRequest.InstituteName"
                 placeholder="Type" pattern="^[\sa-zA-Z0-9,._\-?]*$" #InstituteName="ngModel" maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!InstituteName.valid && InstituteName.errors.pattern)">(special characters are not allowed)</small>-->

        </div>


        <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Save</button>

        </div>-->

        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

      </div>


    </div>

    <!--<div class="row" >
      <div class="card-footer text-right col-12">
        <button type="button"
                (click)="CancelNewOperation()"  class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">
          Cancel
        </button>
        <button type="submit"  class="btn actions-btn-prime nav-link-hand">Save</button>




      </div>
    </div>-->

  </form>
</div>


